













import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import JobsearchRecruiteeSearchBox from "@/components/jobsearch/JobsearchRecruiteeSearchBox.vue";
import { JobsearchRecruiteeSearchParams } from "@/components/jobsearch/JobsearchRecruiteeSearchBox.vue";

import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import JobsearchRecruiteeTable from "@/views/jobsearch/JobsearchRecruiteeTable.vue";
import { PortalJobsearchRecruitee } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    JobsearchRecruiteeSearchBox,
    AppAuthButton,
    JobsearchRecruiteeTable,
  },
})
export default class extends Mixins(AxiosMixin) {
  private searchKey = ""; //絞り込み文字列

  private recruitees: PortalJobsearchRecruitee[] = [];

  private fetchList(searchObj: JobsearchRecruiteeSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_jobsearch_recruitees/get",
      searchObj,
      (res) => {
        this.recruitees = res.data.recruitees || [];
      }
    );
  }
}
